import { EnumSchema } from '../metadata-schema';

export const CohortrendementTotWaarde: EnumSchema = {
	"type": "string",
	"title": "CohortrendementTotWaarde",
	"enum": [
		"Zonder vertraging",
		"Zonder vertraging (prognose)",
		"Boven advies",
		"Boven advies (prognose)",
		"Onder advies",
		"Onder advies (prognose)",
		"Onder advies & gedoubleerd",
		"Onder advies & gedoubleerd (prognose)",
		"Gedoubleerd",
		"Gedoubleerd (prognose)",
		"Boven advies & gedoubleerd",
		"Boven advies & gedoubleerd (prognose)",
		"Afgewezen",
		"Afgewezen (prognose)"
	]
};
